import React from 'react';
import { useEntities } from '../../../data/flowEntities';
import { formatTime, twentyFourHoursAgo } from '../utils';
import { useGlobalSettings } from '../../../app/GlobalSettingProvider';
import { gridClasses } from '@mui/x-data-grid-premium';
import getSyncTableColumns from './FlowEntitySyncTableColumnsDef';
import AQDataGrid from '../../AQDataGrid';
import { Model, ModelCollection } from '../../../data/api';

import { Flow, Job } from '../../../types/flow.types';

interface Account {
  id: string;
}

interface Schedule {
  id: string;
}

interface FlowSyncsTableProps {
  flow: Model | Flow | null;
  currentAccount: Account;
  tabIsActive?: boolean;
}

const FlowSyncsTable = ({
  flow,
  currentAccount,
  tabIsActive,
}: FlowSyncsTableProps) => {
  const { settings } = useGlobalSettings();

  const schedulesQuery = useEntities(
    currentAccount.id,
    'schedule',
    {
      filter: {
        entity_type: 'flow',
        entity_id: flow?.id,
      },
    },
    { enabled: Boolean(flow?.id) && tabIsActive },
  );

  const rowTransform = (schedules: Schedule[]) => (entities: Job[]) =>
    entities?.map((job) => {
      const schedule = schedules.find(
        (schedule) => schedule.id === job.triggered_by_id,
      );
      return {
        ...job,
        id: job.id,
        schedule,
      };
    });

  if (!flow) {
    return null;
  }

  return (
    <AQDataGrid
      dataDependencies={[schedulesQuery]}
      dataQueryHook={useEntities}
      buildQueryArgs={(queryParams) => [
        currentAccount.id,
        'job',
        {
          ...queryParams,
          filter: {
            job_type: 'flow',
            updated_at__gte: settings.datePicker.start,
            updated_at__lte: settings.datePicker.end,
            entity_id: flow.id,
          },
        },
        {
          refetchInterval: 3000,
          enabled: flow && Boolean(flow.id) && tabIsActive,
        },
      ]}
      rowsTransformer={rowTransform(
        (schedulesQuery?.data as ModelCollection)?.data || [],
      )}
      colDefs={getSyncTableColumns(settings, currentAccount, flow?.name)}
      sx={{
        [`& .${gridClasses.menuIcon}`]: {
          visibility: 'visible',
          width: 'auto',
        },
      }}
    />
  );
};

export default FlowSyncsTable;
